<template>
  <div class="loginmodal">
    <div class="msgArt">
      <img src="@/assets/img/icon_airplane.svg" />
      <p>{{ $t('front.message.msgA') }}<br />{{ $t('front.message.msgB') }}</p>
      <a @click="goPageByName('message')">{{ $t('front.board.check') }}</a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NewMessage'
}
</script>

<style scoped>

</style>

<style scoped src="@/styles/header.css"></style>
<style scoped src="@/styles/common.css"></style>
<style scoped src="@/styles/subcommon.css"></style>
